<template>
  <el-row justify="center">
    <el-col :xs="24" :sm="20" :md="16" :lg="12">

      <el-card shadow="never">
        <template #header>
          <div class="card-header">
            <h5 class="mb-0">修改个人资料</h5>
          </div>
        </template>

        <el-alert
          v-if="successMessage"
          :title="successMessage"
          type="success"
          show-icon
          class="mb-3"
          :closable="false"
        />
        <el-alert
          v-if="errorMessage"
          :title="errorMessage"
          type="error"
          show-icon
          class="mb-3"
          :closable="false"
        />

        <el-form
          v-loading="isLoading"
          :model="formData"
          :rules="formRules"
          ref="profileFormRef"
          label-position="top"
          @submit.prevent="handleSubmit"
        >
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="姓名" prop="full_name">
                <el-input v-model="formData.full_name" />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="性别" prop="gender">
                <el-input v-model="formData.gender" />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="政治面貌" prop="is_party_member">
                <el-select v-model="formData.is_party_member" class="w-100">
                  <el-option label="群众" :value="false" />
                  <el-option label="党员" :value="true" />
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="出生年月日" prop="date_of_birth">
                <el-date-picker
                  v-model="formData.date_of_birth"
                  type="date"
                  placeholder="选择日期"
                  format="YYYY-MM-DD"
                  value-format="YYYY-MM-DD"
                  class="w-100"
                />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="电子邮箱" prop="email">
                <el-input
                  v-model="formData.email"
                  placeholder="用于接收密码重置和通知"
                />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="电话号码" prop="phone_number">
                <el-input v-model="formData.phone_number" />
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="工作单位及职务、职称" prop="organization_and_title">
                <el-input
                  v-model="formData.organization_and_title"
                  type="textarea"
                  :rows="3"
                />
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="专业" prop="specialty">
                <el-input v-model="formData.specialty" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item>
            <el-button
              type="primary"
              size="large"
              @click="handleSubmit"
              :loading="isSubmitting"
              class="w-100"
            >
              {{ isSubmitting ? '正在保存...' : '保存更改' }}
            </el-button>
          </el-form-item>
        </el-form>
      </el-card>

    </el-col>
  </el-row>
</template>

<script>
import axios from 'axios';
// 【V4.0 新增】导入 Element Plus 消息提示
import { ElMessage } from 'element-plus';

export default {
  name: 'EditProfileView',
  data() {
    return {
      // 1. 状态
      isLoading: true,      // 页面是否在加载数据
      isSubmitting: false, // 表单是否正在提交

      // 2. 表单数据
      formData: {}, // (保持不变)

      // 3. 提示信息
      successMessage: null,
      errorMessage: null,

      // 4. 【V4.0】 Element Plus 表单验证规则
      formRules: {
        full_name: [
          { required: true, message: '姓名不能为空。', trigger: 'blur' },
        ],
        email: [
          { required: true, message: '电子邮箱不能为空。', trigger: 'blur' },
          { type: 'email', message: '请输入一个有效的电子邮箱地址。', trigger: 'blur' },
        ],
        // (其他字段都是可选的)
      }
    };
  },

  // mounted() 钩子 (已重构)
  async mounted() {
    this.isLoading = true;
    const token = localStorage.getItem('authToken');
    if (!token) {
      this.$router.push('/login');
      return;
    }
    try {
      // (保持不变)
      const response = await axios.get('/members/api/profile/', {
        headers: { 'Authorization': `Token ${token}` }
      });
      this.formData = response.data;
    } catch (error) {
      console.error('获取个人资料失败:', error);
      localStorage.removeItem('authToken');
      this.$router.push('/login');
    } finally {
      this.isLoading = false;
    }
  },

  methods: {
    /**
     * handleSubmit() (已【重构】为使用 el-form 验证)
     */
    async handleSubmit() {
      // 1. 【V4.0】使用 el-form 的 'validate' 方法
      this.$refs.profileFormRef.validate(async (valid) => {
        if (!valid) {
          ElMessage({ type: 'error', message: '请检查您的表单是否填写完整。' });
          return false;
        }

        // --- 验证通过, 开始提交 ---
        this.isSubmitting = true;
        this.successMessage = null;
        this.errorMessage = null;

        const token = localStorage.getItem('authToken');

        try {
          // 2. 【PUT】请求 (保持不变)
          await axios.put('/members/api/profile/', this.formData, {
            headers: { 'Authorization': `Token ${token}` }
          });

          // 3. 处理成功
          this.successMessage = '您的个人资料已成功更新！';
          // (使用 ElMessage 提示)
          ElMessage({ type: 'success', message: '您的个人资料已成功更新！' });

          // (我们不再需要 successMessage, 但可以保留)
          setTimeout(() => {
            this.successMessage = null;
          }, 3000);

        } catch (error) {
          // 4. 处理失败
          console.error('更新资料失败:', error);
          if (error.response && error.response.status === 400 && error.response.data.email) {
             this.errorMessage = error.response.data.email.join(' ');
          } else {
             this.errorMessage = '更新失败，请检查您的填写内容或稍后再试。';
          }
        } finally {
          // 5. 结束“提交”状态
          this.isSubmitting = false;
        }
        // --- 提交结束 ---
      });
    }
  }
};
</script>

<style scoped>
/* --- V4.0 样式 --- */
.w-100 {
  width: 100%;
}
.card-header h5 {
  font-weight: 600;
  margin-bottom: 0;
}
.mb-3 {
  margin-bottom: 1.25rem;
}
</style>